import { useTranslation } from 'src/utils/i18n'

const Bottom = () => {
  const { t } = useTranslation('common')

  return (
    <div className='w-full h-[300px] Bxl:px-[16px] bg-[#1c1e53]'>
      <div className='max-w-[1200px] h-full mx-auto flex flex-col justify-center text-[14px] Bld:text-[12px] text-[#AAA]'>
        <p>{t('DISCLAIMER')}</p>
        <p className='mt-[10px]'>
          {t(
            'You are advised that it is considered a violation of United States federal andor state law in most instances to installsurveillance software such as the Msafely Software onto a mobile phone or other device for which you do not have proper authorizatio and in most cases you are required to notify users of the device that they are being monitored Failure to do so is likely to result in violation of applicable law and may result in severe monetary and criminal penalties imposed on the violator You should consult your own legal advisor with respect to legality of using the Msafely Software in your jurisdiction prior to downloading and using the Msafely Software'
          )}
        </p>
      </div>
    </div>
  )
}

export default Bottom

